import SessionDetails from '../../../guidanceSessions/components/SessionDetails';

export default function SessionDetailsScreen() {
    return <SessionDetails />;
}
